/* src/app/components/pages/order-history/order-history.component.scss */
.table-container {
  overflow: hidden;
  display: flex;
  flex-direction: column;
  height: 500px;
  width: 100%;
}
.orderTable {
  overflow-x: auto;
}
::ng-deep .mat-mdc-table {
  font-family: "IBM Plex Sans", sans-serif !important;
}
mwlResizable {
  box-sizing: border-box;
}
.mat-mdc-header-cell {
  font-weight: 700 !important;
  color: rgb(0, 0, 0);
}
mat-table {
  width: 100%;
}
@media only screen and (max-width: 600px) {
  mat-table {
    overflow-x: scroll;
  }
  mat-table .mat-mdc-row,
  mat-table .mat-mdc-header-row {
    width: 100%;
  }
}
mat-table .mat-mdc-header-cell:nth-child(1),
mat-table .mat-header-cell:nth-child(2),
mat-table .mat-header-cell:nth-child(3),
mat-table .mat-header-cell:nth-child(4),
mat-table .mat-header-cell:nth-child(5),
mat-table .mat-header-cell:nth-child(6),
mat-table .mat-header-cell:nth-child(7),
mat-table .mat-header-cell:nth-child(8) {
  justify-content: start;
}
mat-table .mat-mdc-header-cell:nth-child(9) {
  justify-content: center;
}
mat-table .mat-mdc-cell:nth-child(1),
mat-table .mat-cell:nth-child(6),
mat-table .mat-cell:nth-child(7) {
  justify-content: start;
}
mat-table .mat-mdc-cell:nth-child(2),
mat-table .mat-cell:nth-child(3),
mat-table .mat-cell:nth-child(4),
mat-table .mat-cell:nth-child(5),
mat-table .mat-cell:nth-child(8) {
  justify-content: start;
}
mat-table .mat-mdc-cell:nth-child(9) {
  justify-content: center;
}
mat-table .mat-mdc-cell:nth-child(1),
mat-table .mat-mdc-header-cell:nth-child(1) {
  max-width: 10%;
  justify-content: start;
}
mat-table .mat-mdc-cell:nth-child(5),
mat-table .mat-mdc-header-cell:nth-child(5),
mat-table .mat-cell:nth-child(6),
mat-table .mat-header-cell:nth-child(6),
mat-table .mat-cell:nth-child(7),
mat-table .mat-header-cell:nth-child(7) {
  max-width: 15%;
  justify-content: start;
}
mat-table .mat-mdc-cell:nth-child(2),
mat-table .mat-mdc-header-cell:nth-child(2),
mat-table .mat-cell:nth-child(3),
mat-table .mat-header-cell:nth-child(3),
mat-table .mat-cell:nth-child(4),
mat-table .mat-header-cell:nth-child(4) {
  max-width: 10%;
  justify-content: start;
}
mat-table .mat-mdc-cell:nth-child(8),
mat-table .mat-mdc-header-cell:nth-child(8) {
  max-width: 25%;
  justify-content: start;
}
mat-table .mat-mdc-cell:nth-child(9),
mat-table .mat-mdc-header-cell:nth-child(9) {
  max-width: 15%;
  justify-content: center;
}
.page_orderhistory th {
  background-color: #fff;
  vertical-align: middle;
  font-weight: 500;
  color: #333;
  border-width: 1px;
  text-transform: uppercase;
}
.orderhistory_table {
  margin: 2%;
}
.title {
  background: black;
  color: #fff;
  padding-top: 10px;
  padding-bottom: 10px;
  text-align: center;
  font-size: 20px;
  font-weight: 800;
  letter-spacing: 0.3px;
}
.orderId {
  color: #51c1e8;
  font-weight: 500;
}
/*# sourceMappingURL=order-history.component.css.map */
